<div class="flex items-center space-x-3">
    <span class="h-4 w-4 {{ outerColor }} rounded-full flex items-center justify-center" aria-hidden="true">
        <span class="h-2 w-2 {{ innerColor }} rounded-full"></span>
    </span>
    <span class="block font-medium">{{ caption }}</span>
</div>
